import React from "react";
import { VendorRevendorizationList } from "./List";
import { Box, Divider, Typography } from "@mui/material";

export default function VendorRevendorizationPage() {
  return (
    <Box paddingX="32px" display="flex" width="100%" justifyContent="center">
      <Box width="100%" maxWidth="1536px">
        <Typography variant="h4" component="h1" gutterBottom>
          Vendor Remappings
        </Typography>
        <Divider />
        <VendorRevendorizationList />
      </Box>
    </Box>
  );
}
